import { Component, OnInit } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { FallbackCellType, VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import { SortDirection } from "@app/enum/SortDirection";
import { SortType } from "@app/enum/SortType";
import { SensorDataService } from "../../sensor-data.service";
import { IVehicleWithSensorDataValues } from "../../_models/IVehicleWithSensorData";
import "./sensor-data.component.scss";

@Component({
    selector: 'sensor-data1',
    template: require("./sensor-data.component.html")
})
export class SensorDataComponent implements OnInit {
    tableColumns: IVTableColumn<IVehicleWithSensorDataValues>[] = [];
    tableRows: IVTableRow<IVehicleWithSensorDataValues>[] = [];

    sensorData: IVehicleWithSensorDataValues[] = [];
    loading: boolean;

    selectedVehicle: IVehicleWithSensorDataValues;

    constructor(
        private readonly vTableService: VTableService,
        private readonly sensorDataService: SensorDataService
    ) { }

    async ngOnInit(): Promise<void> {
        this.createTableColumns();
        await this.loadSensorData();
    }

    rowSelected(row: IVTableRow<IVehicleWithSensorDataValues>): void {
        this.selectedVehicle = row.data;
    }

    onHistoryClosed(): void {
        this.selectedVehicle = null;
    }

    private createTableColumns(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createVehicleTableHeader(),
                createCellFunction: (data) => this.vTableService.createVehicleRegCell(data)
            },
            {
                header: this.vTableService.createTableHeader({
                    tKey: "SensorData.EngineHoursTotal",
                    sortType: SortType.Number,
                    sorted: true,
                    sortDirection: SortDirection.Descending
                }),
                createCellFunction: (data) => this.vTableService.createTableCell(this.sensorDataService.getEngineHours(data.latestSensorDataValues), {}, FallbackCellType.NA)
            },
        ]
    }

    private createTableRows(): void {
        this.tableRows = this.vTableService.createTableRows(this.sensorData, this.tableColumns);
    }

    private async loadSensorData(): Promise<void> {
        this.loading = true;
        this.sensorData = await this.sensorDataService.getLatestVehiclesSensorData();

        this.createTableRows();
        this.loading = false;
    }
}
